<template>
  <div class="field-wrapper p-4">
    <label :for="id" class="text-sm px-2">{{ label }}</label>
    <fieldset :id="id">
      <label v-for="(option, key) in options" :key="key">
        <input type="radio" :value="option.value" :name="name" v-model="inputVal"/>
        {{ option.label }}
      </label>
    </fieldset>
</div>
</template>

<script>
    export default {
      props: ['name', 'id', 'label', 'options', 'value'],
      computed: {
        inputVal: {
          get () {
            return this.value
          },
          set (val) {
            this.$emit('input', val)
          }
        }
      }
    }

</script>

<style lang="scss" scoped>
  .field-wrapper {
    display: block;
    overflow: hidden;
    label {
      display: block;
      text-align: left;
      font-weight: 600;
      text-transform: uppercase;
    }
    input {
      position: static;
      left: auto;
    }
  }
</style>
